<template lang="pug">
  div.wrap-module-profile.f.fh
    div.profile-content.py28
      div.wrap-icon.f.fc.mb8
        v-avatar(size="120").mb8
          v-img(:src="user.iconPhotoURL")
      span.block.text-center.fz16.bold.mb6 {{user.displayName}}
      span.block.text-center.fz14.mb16 ライセンス取得年月日：{{certifiedDateLabel}}
      span.block.text-center.fz14 {{user.profile ? user.profile : 'プロフィールがありません'}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-profile {
  padding-top: $header_height;
  min-height: 100vh;
  .profile-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import { format } from 'date-fns'

export default {
  components: {
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    certifiedDateLabel () {
      return format(this.user.certifiedAt.toDate(), 'yyyy/MM/dd')
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>
